(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aorvo-contact-support"]) return;
  try {
    
(() => {
 const init = () => {
  const root = document.querySelector('[data-aorvo-contact-hub]');
  if (!root || root.dataset.receiverInitialized) return;
  root.dataset.receiverInitialized = 'true';
  root.querySelector('[data-aorvo-open-inbox]')?.addEventListener('click', async () => {
   for (let attempt = 0; attempt < 25; attempt++) {
    const chat = document.querySelector('shopify-chat');
    if (chat?.hasAttribute('open')) return;
    const roots = chat?.shadowRoot ? [chat.shadowRoot] : [];
    let activator = null;
    for (let index = 0; index < roots.length && !activator; index++) {
     const layer = roots[index];
     activator = layer.querySelector('button[part~="activator"]');
     for (const element of layer.querySelectorAll('*')) if (element.shadowRoot) roots.push(element.shadowRoot);
    }
    if (activator) { setTimeout(() => activator.click(), 0); return; }
    await new Promise(resolve => setTimeout(resolve, 200));
   }
  });
  const form = root.querySelector('#aorvo_pre_purchase_contact');
  const box = form.querySelector('[data-aorvo-contact-context]');
  const confirm = form.querySelector('#AorvoConfirmContext');
  const intent = form.querySelector('#AorvoPrePurchaseIntent');
  const intents = [...intent.options].map(option => option.value);
  const fields = ['AorvoAssistedProductTitle','AorvoAssistedProductId','AorvoAssistedVariantId','AorvoAssistedOptions','AorvoAssistedPdpUrl','AorvoAssistedSku','AorvoAssistedVariantTitle'].map(id => form.querySelector('#'+id));
  const key = 'aorvoAssistedCommerceContextV2';
  const text = (v,max) => typeof v === 'string' && v.length > 0 && v.length <= max && !/[\u0000-\u001f\u007f]/.test(v);
  const id = v => typeof v === 'string' && /^[1-9][0-9]{5,19}$/.test(v);
  let context = null;
  let generation = 0;
  function erase() { try { sessionStorage.removeItem(key); } catch (_) {} }
  function validate(raw) {
   if (typeof raw !== 'string' || raw.length > 4096) return null;
   try {
    const c=JSON.parse(raw), keys=['productTitle','productLegacyId','variantId','selectedOptions','pdpUrl','requestType'];
    if (!c || Array.isArray(c) || typeof c !== 'object' || Object.keys(c).length !== keys.length || !keys.every(k => Object.hasOwn(c,k))) return null;
    if (!text(c.productTitle,240) || !id(c.productLegacyId) || !id(c.variantId) || !intents.includes(c.requestType)) return null;
    if (!Array.isArray(c.selectedOptions) || c.selectedOptions.length < 1 || c.selectedOptions.length > 3 || !c.selectedOptions.every(x=>text(x,120))) return null;
    if (!text(c.pdpUrl,1024)) return null;
    const u = new URL(c.pdpUrl), base = new URL(root.dataset.rootUrl,location.origin);
    const prefix=base.pathname.replace(/\/$/,'')+'/products/';
    if (u.origin !== location.origin || u.username || u.password || u.hash || !u.pathname.startsWith(prefix) || !/^[a-z0-9][a-z0-9-]*\/?$/.test(u.pathname.slice(prefix.length))) return null;
    if (u.searchParams.getAll('variant').length > 1 || u.searchParams.getAll('preview_theme_id').length > 1) return null;
    if (u.searchParams.has('variant') && u.searchParams.get('variant') !== c.variantId) return null;
    if (u.searchParams.has('preview_theme_id') && !id(u.searchParams.get('preview_theme_id'))) return null;
    const clean = new URL(u.pathname, location.origin);clean.searchParams.set('variant',c.variantId);
    return {...c,pdpUrl:clean.href};
   } catch (_) { return null; }
  }
  function sync() {
   const included=Boolean(context && confirm.checked);
   const values=context ? [context.productTitle,context.productLegacyId,context.variantId,context.selectedOptions.join(' / '),context.pdpUrl,context.sku,context.variantTitle] : [];
   fields.forEach((field,i)=>{field.disabled=!included || !values[i];field.value=included ? values[i] || '' : '';});
   box.hidden=!context;
   form.querySelector('[data-aorvo-contact-context-state]').textContent=included ? root.dataset.included : root.dataset.excluded;
  }
  function render() {
   if (!context) { sync();return; }
   form.querySelector('[data-aorvo-context-title]').textContent=context.productTitle;
   form.querySelector('[data-aorvo-context-options]').textContent=context.selectedOptions.join(' / ');
   form.querySelector('[data-aorvo-context-options]').hidden=context.defaultOnly;
   form.querySelector('[data-aorvo-variant-value]').textContent=context.variantTitle;
   form.querySelector('[data-aorvo-context-variant]').hidden=!context.variantTitle;
   form.querySelector('[data-aorvo-sku-value]').textContent=context.sku;
   form.querySelector('[data-aorvo-context-sku]').hidden=!context.sku;
   form.querySelector('[data-aorvo-context-link]').href=context.pdpUrl;
   const image=form.querySelector('[data-aorvo-context-image]');image.hidden=!context.image;
   if(context.image){image.src=context.image;image.alt=context.productTitle;}else{image.removeAttribute('src');image.alt='';}
   sync();
  }
  async function receive() {
   const ticket=++generation;context=null;confirm.checked=false;intent.value=intents[0];sync();root.dataset.contextState='generic';
   let raw=null;try {raw=sessionStorage.getItem(key);}catch (_) {}erase();
   const c=validate(raw);if(!c)return;
   root.dataset.contextState='verifying';
   try {
    const url=new URL(c.pdpUrl);url.search='';url.pathname=url.pathname.replace(/\/$/,'')+'.js';
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
    let response;try {response=await fetch(url.href,{credentials:'same-origin',signal:controller.signal,headers:{Accept:'application/json'}});}finally{clearTimeout(timer);}
    if(!response.ok)throw new Error('product unavailable');
    const p=await response.json(),v=Array.isArray(p.variants) && p.variants.find(x=>String(x.id)===c.variantId);
    if(String(p.id)!==c.productLegacyId || !v || p.title!==c.productTitle || !Array.isArray(v.options) || v.options.length!==c.selectedOptions.length || !v.options.every((x,i)=>x===c.selectedOptions[i])) throw new Error('selection mismatch');
    let image='';
    const candidate=v.featured_image?.src || p.featured_image;
    if(typeof candidate==='string') { const img=new URL(candidate,location.origin);if(img.protocol==='https:' && (img.hostname==='cdn.shopify.com' || img.origin===location.origin && img.pathname.startsWith('/cdn/shop/'))) {img.searchParams.set('width','224');image=img.href;} }
    if(ticket!==generation)return;
    context={...c,sku:typeof v.sku==='string'?v.sku:'',variantTitle:typeof v.title==='string'&&v.title!=='Default Title'?v.title:'',image,defaultOnly:p.variants.length===1 && v.title==='Default Title' && v.options.length===1 && v.options[0]==='Default Title'};
    root.dataset.contextState='verified';render();
   }catch(_){if(ticket===generation){root.dataset.contextState='generic';context=null;sync();}}
  }
  confirm.addEventListener('change',()=>{if(confirm.checked && context)intent.value=context.requestType;sync();});
  intent.addEventListener('change',sync);
  form.querySelector('#AorvoClearContext').addEventListener('click',()=>{generation++;context=null;confirm.checked=false;intent.value=intents[0];erase();root.dataset.contextState='generic';sync();});
  form.addEventListener('submit',sync);
  window.addEventListener('pageshow',event=>{if(event.persisted)receive();});
  receive();
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aorvo-pdp-purchase-confidence"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('[data-aorvo-legacy-help]').forEach(root => {
      if (root.dataset.helpInitialized) return;
      root.dataset.helpInitialized = 'true';
      root.querySelectorAll('[data-aorvo-legacy-product-help]').forEach(link => {
        link.addEventListener('click', () => {
          const key = 'aorvoAssistedCommerceContextV2';
          try {
            sessionStorage.removeItem(key);
            const containers = document.querySelectorAll('main .product-template__container[data-section-id]');
            if (containers.length !== 1) return;
            const main = containers[0];
            const form = document.getElementById('product-form-' + main.dataset.sectionId);
            if (!form || !main.contains(form)) return;
            const fields = form.querySelectorAll('[name="id"]');
            if (fields.length !== 1) return;
            const variants = JSON.parse(root.querySelector('[data-aorvo-legacy-help-variants]').textContent);
            const variant = variants.find(item => String(item.id) === String(fields[0].value));
            if (!variant || !Array.isArray(variant.options)) return;
            const url = new URL(root.dataset.aorvoHelpProductUrl, location.origin);
            url.searchParams.set('variant', String(variant.id));
            sessionStorage.setItem(key, JSON.stringify({
              productTitle: root.dataset.aorvoHelpProductTitle,
              productLegacyId: root.dataset.aorvoHelpProductId,
              variantId: String(variant.id),
              selectedOptions: variant.options.filter(Boolean),
              pdpUrl: url.href,
              requestType: 'Product question'
            }));
          } catch (_) {}
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
